/* src/app/home-new/lamination-options/lamination-options.component.scss */
.new-style {
  background-color: #fff;
  border-radius: 20px;
  border: 1px solid #949494;
  padding: 10px;
}
.new-style h4 {
  color: #949494;
  text-align: left;
  margin-left: 5px;
  font-weight: 600 !important;
  font-size: 16px !important;
}
.new-style .option-button {
  --background-activated: #cbcbcb3a;
}
.new-style .option-button span {
  color: #000 !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  display: flex;
  padding: 5px 0px 5px 8px;
}
.new-style .option-button:hover.selected::part(native) {
  border: 2px solid var(--ion-color-secondary);
  --background-hover: #f5b2004d;
  --background-activated: #f5b2004d;
}
.new-style .option-button.selected::part(native) {
  background:
    linear-gradient(
      0deg,
      rgba(245, 178, 0, 0.2) 0%,
      rgba(245, 178, 0, 0.2) 100%),
    #37373e;
  border: 2px solid var(--ion-color-secondary);
}
.new-style .laminationTypeButton.selected {
  outline: 4px solid rgba(245, 178, 0, 0.3019607843);
}
.new-style .file-text {
  color: #949494;
  font-size: 16px;
}
.new-style .option-button .weightSubtitle {
  color: #949494 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 15px;
  margin-left: 0 !important;
}
h4 {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  margin-top: 10px;
}
.option-button::part(native) {
  min-width: unset;
  padding: 0;
  border: 1px solid #949494;
}
.option-button .bottom-section {
  padding: 10px;
}
.option-button .bottom-section.selected {
  background:
    linear-gradient(
      0deg,
      rgba(245, 178, 0, 0.2) 0%,
      rgba(245, 178, 0, 0.2) 100%),
    #37373e;
}
.option-button .radio-selector {
  height: 16px;
  width: 16px;
  border-radius: 100%;
  border: 1px solid #949494;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.option-button .radio-selector.selected {
  background-color: #f5b200;
  border: none;
}
.option-button .radio-selector.selected .inner-radio-selector {
  display: block;
}
.option-button .radio-selector .inner-radio-selector {
  display: none;
  background-color: white;
  height: 10px;
  width: 10px;
  border-radius: 100%;
  position: absolute;
}
.option-button .laminationWeightButton {
  padding: 0 10px;
}
.option-button span {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: black;
}
.option-button:hover {
  opacity: 1 !important;
}
.option-button:hover::part(native) {
  min-width: unset;
  padding: 0;
  border: 1px solid rgba(148, 148, 148, 0.6);
}
.option-button:hover.selected::part(native) {
  border: 2px solid rgba(67, 192, 246, 0.6);
}
.option-button:hover span {
  opacity: 0.6;
}
.option-button.selected::part(native) {
  background-color: rgba(67, 192, 246, 0.05);
  border: 2px solid #43c0f6;
}
hr {
  border-top: 1px solid #cbcbcb;
  border-bottom: 1px solid #cbcbcb;
  margin: 15px 0;
}
.weightTitle {
  font-family: "Barlow Semi Condensed", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color: black !important;
}
.weightSubtitle {
  font-family: "Barlow Semi Condensed", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: black !important;
}
.laminationTypeButton {
  border-radius: 10px;
  overflow: hidden;
  outline: 1px solid #949494;
  height: 36px;
}
.laminationTypeButton.selected {
  outline: 4px solid rgba(67, 192, 246, 0.6);
}
.laminationTypeButton ion-radio {
  display: flex;
  width: 100%;
  padding: 0 10px 0 10px;
}
.file-text {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: black;
}
.file-text.bold {
  font-weight: 600;
}
ion-radio.no-margin::part(label) {
  -webkit-margin-end: 0 !important;
  margin-inline-end: 0 !important;
}
.container-type {
  border: 1px solid #cbcbcb;
  padding: 10px;
  border-radius: 10px;
}
.tooltip-icon {
  width: 16px;
  height: 16px;
  z-index: 99;
  cursor: pointer;
  color: gray;
}
.new-style .option-button .bottom-section {
  align-items: center;
  gap: 8px;
  justify-content: space-between;
}
.new-style .option-button .custom-radio {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #949494;
  background: #fff;
  position: relative;
  transition: border-color 0.2s, background 0.2s;
  box-sizing: border-box;
  margin-right: 5px;
}
.new-style .option-button .custom-radio.selected::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 7px;
  height: 7px;
  background: #fff;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}
.new-style .option-button .custom-radio.selected {
  background: #f5b200;
  border-color: #f5b200;
}
.new-style .option-button.selected::part(native) {
  background: var(--Colores-secundarios-AMARILLO-CLARO, #fff0c6) !important;
  border: 1.5px solid var(--Colores-secundarios-AMARILLO-OSCURO, #d59b00) !important;
  box-shadow: 0 2px 15px 0 rgba(245, 178, 0, 0.3) !important;
}
/*# sourceMappingURL=lamination-options.component-FPJGH6EI.css.map */
